import React from "react";
export default function ShareLinks(props) {
    var _props_shareLink;
    return /*#__PURE__*/ React.createElement("div", {
        className: "mb-10 md:mb-14"
    }, /*#__PURE__*/ React.createElement("h4", {
        className: "font-heading font-medium mb-5 text-lg md:text-xl"
    }, props.heading), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap gap-x-6"
    }, (_props_shareLink = props.shareLink) === null || _props_shareLink === void 0 ? void 0 : _props_shareLink.map(function(item, index) {
        /*#__PURE__*/ return React.createElement("a", {
            key: index,
            href: item === null || item === void 0 ? void 0 : item.link,
            target: "_blank",
            rel: "nofollow noreferrer"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "sr-only"
        }, item === null || item === void 0 ? void 0 : item.type), (item === null || item === void 0 ? void 0 : item.type) === "facebook" ? /*#__PURE__*/ React.createElement("img", {
            src: "/images/facebook.svg",
            alt: "Facebook icon",
            width: "10px",
            height: "18px"
        }) : null, (item === null || item === void 0 ? void 0 : item.type) === "twitter" ? /*#__PURE__*/ React.createElement("img", {
            src: "/images/twitter.svg",
            alt: "Twitter icon",
            width: "21px",
            height: "18px"
        }) : null, (item === null || item === void 0 ? void 0 : item.type) === "xing" ? /*#__PURE__*/ React.createElement("img", {
            src: "/images/xing.svg",
            alt: "Xing icon",
            width: "15px",
            height: "18px"
        }) : null, (item === null || item === void 0 ? void 0 : item.type) === "linkedin" ? /*#__PURE__*/ React.createElement("img", {
            src: "/images/linkedin.svg",
            alt: "LinkedIn icon",
            width: "18px",
            height: "18px"
        }) : null, (item === null || item === void 0 ? void 0 : item.type) === "mail" ? /*#__PURE__*/ React.createElement("img", {
            src: "/images/mail.svg",
            alt: "Email icon",
            width: "18px",
            height: "14px"
        }) : null);
    })));
}
